<template>
    <b-container class="m-0 p-0">

         <b-container v-for="(item, index) in tradePointDaxContacts" :key="index">

            <b-row class="mb-20">
                    <b-col class="pr-5">
                    <label :for="`name-${index}`" class="tt-edit-label"> ФИО* </label>
                    <b-form-input :id="`name-${index}`" v-model="item.Name" />
                </b-col>
                <b-col class="pl-5">
                    <label :for="`phoneDax-${index}`" class="tt-edit-label"> Номер </label>
                    <b-form-input :id="`phoneDax-${index}`" v-model="item.Phone" placeholder="Контактный телефон"/>
                </b-col>         
            </b-row>

            <b-row class="mb-20">
                <label :for="`right-${index}`" class="tt-edit-label"> Права* </label>
                <custom-multiselect :id="`right-${index}`" v-model="item.Type" :options="rights" />
            </b-row>

            <b-button id="text-roman"
                      class="button-blue" 
                      variant="outline-primary"
                      @click="deleteDaxContact(index)">
                Удалить контакт
            </b-button>

            <hr v-if="index != tradePointDaxContacts.length-1" class="my-4 hr-green-client" />

        </b-container>

        <hr v-if="tradePointDaxContacts.length" class="my-4 hr-green-client"/>

        <b-button id="text-roman" 
                  class="button-blue"
                  variant="outline-primary"                  
                  @click="addDaxContact">
            Добавить контакт
        </b-button>

    </b-container>
</template>
<script>
import CustomMultiselect from '@/components/shared/CustomMultiSelect'

import Consts from '@/store/models/consts/clientConsts'
import DaxContactModel from '@/store/models/client/tradePoints/DaxContact'

export default {
    props: {
        options: {
            type: Array,
            default: () => []
        }
    },
    data: function() {
        return {
            rights: Consts.UserRights,
            tradePointDaxContacts: this.options
        }
    },
    methods: {
        addDaxContact: function() {
            this.tradePointDaxContacts.push(new DaxContactModel());
        },
        deleteDaxContact: function(index) {
            this.tradePointDaxContacts.splice(index, 1);
        }
    },
    components: {
        CustomMultiselect
    }
}
</script>

<style>
#text-roman {
    font-family: 'HelveticaNeueCyr-roman'; 
    letter-spacing: 0; 
    text-transform: none;
}
</style>